import { EllipsisOutlined } from '@ant-design/icons'
import { useParkingLot } from '@services/operation'
import { IconLocation } from '@shared/icons'
import useWatchMap from '@shared/InnmaxMap2/hooks/useWatchMap'
import { Dropdown } from '@shared/innmaxUI/Dropdown'
import { Skeleton } from 'antd'
import cx from 'classnames'
import { pathOr } from 'ramda'
import React from 'react'
import { useHistory } from 'react-router-dom'
import { CHARGING_POINT_MANAGEMENT } from 'src/routes'
import { useDashboardContext } from '../../Provider'
import MainSidebar from '../MainSidebar'
import ChargingPointRow from './ChargingPointRow'

const ParkingLotSidebar = () => {
  const { mapInstance, setSelectedChargingPoint } = useDashboardContext()
  const focusParkingLot = useWatchMap(mapInstance, 'focusParkingLot')

  const { isLoading, dataSource } = useParkingLot(focusParkingLot?.id)

  React.useEffect(() => {
    setSelectedChargingPoint(null)
  }, [focusParkingLot])

  const history = useHistory()

  return (
    <MainSidebar
      visible={!!focusParkingLot}
      headerMoreAction={
        <Dropdown
          menu={[
            {
              key: 'more',
              label: '看更多',
              onClick: () => {
                history.push(CHARGING_POINT_MANAGEMENT)
              },
            },
          ]}>
          <EllipsisOutlined className="text-white rotate-90" />
        </Dropdown>
      }
      onClose={() => {
        mapInstance?.setFocusParkingLot(undefined)
      }}>
      {isLoading ? (
        <div className="overflow-hidden px-[10px]">
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </div>
      ) : (
        <div className="overflow-hidden text-white flex flex-col gap-[5px] px-[10px]">
          <div className="text-lg font-bold whitespace-pre-line break-words">
            {dataSource?.name}
          </div>
          <div className="truncate text-[#859FAA]">
            <IconLocation />
            {pathOr('', ['properties', 'city'], dataSource)}
            {pathOr('', ['properties', 'town'], dataSource)}
            {pathOr('', ['properties', 'description'], dataSource)}
          </div>
          <div
            className={cx(
              'flex justify-between  rounded-[4px]',
              'border border-[#20E4FF]',
              'bg-linear-to-b from-[#34E8F200] to-[#34e8f269] to-80%'
            )}>
            {[
              {
                dataIndex: 'parkingSpaceCount',
                title: '車格數',
              },
              {
                dataIndex: 'dcChargingPointCount',
                title: '快充',
              },
            ].map((item, index, arr) => (
              <div
                key={item.dataIndex}
                className={`flex flex-col items-center justify-center py-2 w-full ${
                  index !== arr.length - 1
                    ? 'border-r border-[#20E4FF]'
                    : undefined
                }`}>
                <div className="text-lg text-white font-medium">
                  {pathOr(0, [item.dataIndex], dataSource)}
                </div>
                <div className="text-sm text-[#20E4FF]">{item.title}</div>
              </div>
            ))}
          </div>

          <div className="truncate text-white text-sm flex flex-col gap-[10px]">
            <div>
              DC接頭數量:
              {pathOr('--', ['dcChargingPointCount'], dataSource)}
            </div>
          </div>
          <ChargingPointRow
            chargingPoints={pathOr([], ['chargingPoints'], dataSource)}
          />
        </div>
      )}
    </MainSidebar>
  )
}

export default ParkingLotSidebar
